import { render, staticRenderFns } from "./grayDtu.vue?vue&type=template&id=5ff2380a&scoped=true"
import script from "./grayDtu.vue?vue&type=script&lang=js"
export * from "./grayDtu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff2380a",
  null
  
)

export default component.exports